import moment from 'moment'

const LIMITED_TIME_DAYS_QUANTITY = 28

export default (offer: App.Offer | App.OfferSummary): boolean => {
  const scheduleEndDate = offer.onlinePurchaseSchedule?.end
  if (!scheduleEndDate) {
    return false
  }

  const now = moment().utc()
  const end = moment.utc(scheduleEndDate)

  const leftToTheEnd = moment.duration(end.diff(now))
  const endDays = Math.round(leftToTheEnd.asDays())

  return endDays <= LIMITED_TIME_DAYS_QUANTITY
}
